// src/composables/useTranslation.js

// La // src/composables/useTranslation.js
import { ref, watch } from 'vue'

// Fonction pour obtenir la langue depuis localStorage ou par défaut
const getInitialLanguage = () => {
  // 1. Vérifier localStorage en premier
  const savedLanguage = localStorage.getItem('neolinks-language')
  if (savedLanguage && ['fr', 'en'].includes(savedLanguage)) {
    return savedLanguage
  }
  
  // 2. Détecter la langue du navigateur en fallback
  const browserLanguage = navigator.language?.split('-')[0]
  if (browserLanguage && ['fr', 'en'].includes(browserLanguage)) {
    return browserLanguage
  }
  
  // 3. Français par défaut
  return 'fr'
}

// Initialiser avec la langue sauvegardée ou détectée
const currentLanguage = ref(getInitialLanguage())

// Watcher pour sauvegarder automatiquement les changements
watch(currentLanguage, (newLanguage) => {
  localStorage.setItem('neolinks-language', newLanguage)
}, { immediate: true })




const translations = {
  // FRANÇAIS
  fr: {
    // Header
    'menu.home': 'Accueil',
    'menu.features': 'Fonctionnalités', 
    'menu.pricing': 'Tarifs',
    'menu.faq': 'FAQ',
    'button.getYourNeolink': 'Obtenez votre neolinks',
    
    // Hero section - NOUVELLES TRADUCTIONS
    'hero.title.part1': 'VOTRE',
    'hero.title.part2': 'PROFIL', 
    'hero.title.part3': 'DIGITAL',
    'hero.subtitle': 'Centralisez tous vos liens en un seul endroit : réseaux sociaux, boutique, formations... Transformez votre Neolinks en véritable carte de visite digitale.',
    'hero.button.order': 'Commander maintenant',
    'hero.button.login': 'Se connectez', 

    // Product section 

      // ProductSection
      'product.video.title': 'Comment créer votre profil digital avec neolinks',
      'product.button.start': 'Commencer maintenant',
      'product.button.youtube': 'Voir sur YouTube',
      'product.benefit1.title': 'Configuration rapide',
      'product.benefit1.description': 'Profil opérationnel en moins de 5 minutes',
      'product.benefit2.title': 'Partage instantané', 
      'product.benefit2.description': 'Toutes vos informations en un seul tap',
      'product.benefit3.title': 'Toujours à jour',
      'product.benefit3.description': 'Modifiez vos informations à tout moment',


        // FeatureSection


        // Remplacer l'ancienne ligne :
'features.title': 'Fonctionnalités pour constituer  un profil digital',
// Par :
'features.mainTitle': 'Toutes nos fonctionnalités pour votre succès digital',

// Ajouter ces nouvelles traductions :
'features.linkInBio.title': 'Link in Bio',
'features.linkInBio.description': 'Centralisez tous vos liens en un seul endroit',
'features.dashboard.title': 'Dashboard',
'features.dashboard.description': 'Statistiques détaillées et stratégie digitale pour  le personnal branding',
'features.networking.title': 'Networking',
'features.networking.description': ' ideal  pour Conférences, salons et événements',
'features.qrVcard.title': 'Digital Sharing',
'features.qrVcard.description': 'Partage instantané ',
'features.content.title': 'Contenu',
'features.content.description': 'Ebooks, vidéos, produits et plus',
'features.socialMedia.title': 'Réseaux Sociaux',
'features.socialMedia.description': 'Connectez tous vos profils',
'features.appLinks.title': 'App Links',
'features.appLinks.description': 'Redirection mobile intelligente',
'features.themes.title': 'Thèmes',
'features.themes.description': 'Designs personnalisables',
'features.whatsapp': 'WhatsApp',

       // PricingSection

       'pricing.title': 'Choisissez votre plan',
  
       // ESSENTIEL
       'pricing.essential.title': 'Essentiel',
       'pricing.essential.subtitle': 'Pour les particuliers',
       'pricing.essential.price': '5 000',
       'pricing.essential.currency': 'FDJ',
       'pricing.essential.period': 'an',
       'pricing.essential.features': [
         'Lien personnel bio',
         'Réseaux sociaux',
         'Liens personnalisés (portfolio, formations...)',
         'Mode carte visite digital',
         'Statistiques',
         'Thèmes'
       ],
       'pricing.essential.button': 'Commencer',
       
       // VIP SILVER
       'pricing.silver.title': 'VIP Silver',
       'pricing.silver.subtitle': 'Pour les professionnels',
       'pricing.silver.price': '10 000',
       'pricing.silver.currency': 'FDJ',
       'pricing.silver.period': 'an',
       'pricing.silver.features': [
         'Tout le plan Essentiel',
         'Domaine spécial username.neolinks.me',
         'Priorité support client',
         'Carte visite premium argentée',
         'Analytics avancés',
         'Sans publicité'
       ],
       'pricing.silver.button': 'Choisir Silver',
       
       // GOLDEN VIP
       'pricing.gold.title': 'Golden VIP',
       'pricing.gold.subtitle': 'Pour les experts',
       'pricing.gold.price': '15 000',
       'pricing.gold.currency': 'FDJ',
       'pricing.gold.period': 'an',
       'pricing.gold.features': [
         'Tout le plan Silver',
         'Carte visite premium dorée',
         'Domaine personnalisé',
         'Support prioritaire 24/7',
         'Intégrations avancées',
         'Branding personnalisé'
       ],
       'pricing.gold.button': 'Choisir Gold',
       
       // ENTREPRISE
       'pricing.enterprise.title': 'Entreprise',
       'pricing.enterprise.subtitle': 'Pour une équipe',
       'pricing.enterprise.price': 'Sur mesure',
       'pricing.enterprise.features': [
         'Solutions multi-utilisateurs',
         'Branding personnalisé',
         "Domaines d'entreprise",
         'Gestion centralisée',
         'Support dédié',
         'Formation équipe',
         'API intégration'
       ],
       'pricing.enterprise.button': 'Contacter les ventes',


          // FaqSection
    'faq.title': 'Questions fréquemment posées',
    'faq.q1.question': 'Comment fonctionne neolinks ?',
    'faq.q1.answer': 'Neolinks vous crée un profil digital unique accessible via votre lien personnalisé (ex: neolinks.me/votrenom). Placez ce lien dans vos bios Instagram, LinkedIn, TikTok pour être facilement découvert sur tous vos réseaux. Vos contacts accèdent instantanément à vos informations : réseaux sociaux, portfolio, formations, boutique e-commerce, coordonnées, et peuvent enregistrer votre contact en un clic. Un seul lien pour tout centraliser !',
    'faq.q2.question': 'Puis-je mettre à jour mes informations après création ?',
    'faq.q2.answer': 'Absolument ! Vous pouvez mettre à jour vos informations à tout moment via votre tableau de bord. Modifiez vos liens, changez votre photo, ajoutez de nouveaux réseaux sociaux - tous les changements sont reflétés immédiatement sur votre profil neolinks.',
    'faq.q3.question': 'Comment puis-je convertir mon neolinks en carte business digitale ?',
    'faq.q3.answer': 'Rendez-vous sur votre tableau de bord, allez dans "Modifier votre profil" et activez le "Mode Business". Votre profil devient alors scannable par QR code par vos interlocuteurs, avec un bouton "Enregistrer contact" qui permet d\'ajouter instantanément vos informations dans leur carnet d\'adresses.',

    'faq.q4.question': 'Quelle est la différence entre les plans Essentiel et Professionnel ?',
    'faq.q4.answer': 'Le plan Essentiel (15$/an) offre toutes les fonctionnalités de base : lien bio, réseaux sociaux, liens personnalisés, mode carte business et statistiques. Le plan Professionnel (25$/an) ajoute un domaine personnalisé (votrenom.neolink.me), des analytiques avancées, des thèmes personnalisés et un support prioritaire.',



    'contact.save': 'Enregistrer',

    // Footer

    'footer.copyright': 'Tous droits réservés.',
    'footer.backToTop': 'Retour en haut',

        // InscriptionView
        'inscription.title': 'Créer votre compte',
        'inscription.subtitle': 'Commencez avec votre neolinks',
        'inscription.placeholder.name': 'Entrez votre nom complet',
        'inscription.placeholder.email': 'Email',
        'inscription.emailInfo': 'Un Email de confirmation sera envoyé à votre adresse email pour finaliser votre inscription et créer votre mot de passe.',
        'inscription.terms': 'J\'accepte les conditions d\'utilisation et la politique de confidentialité',
        'inscription.loading': 'Chargement...',
        'inscription.submit': 'Soumettre',
        'inscription.or': 'ou',
        'inscription.loginButton': 'Connexion',
        'inscription.backText': 'Retournez',
        'inscription.homeLink': 'Accueil',
        'inscription.success': 'Inscription réussie ! Veuillez vérifier votre email pour confirmer votre compte et créer un mot de passe.',
        'inscription.error': 'L\'inscription a échoué. Veuillez réessayer.',

'inscription.claimLink': 'Réclamez votre lien unique',
'inscription.placeholder.username': 'votrenom',
'inscription.usernameAvailable': '✅ Disponible!',
'inscription.usernameRequirements': '3-20 caractères, lettres et chiffres uniquement',
'inscription.referral.invited': 'Vous avez été invité par un partenaire !',
'inscription.referral.code': 'Code de parrainage :',
           // LoginView
    'login.title': 'Bon retour',
    'login.subtitle': 'Connectez-vous à votre compte neolinks',
    'login.placeholder.email': 'nom@exemple.com',
    'login.placeholder.password': 'Entrez votre mot de passe',
    'login.rememberMe': 'Se souvenir de moi',
    'login.forgotPassword': 'Mot de passe oublié?',
    'login.loading': 'Chargement...',
    'login.signIn': 'Se connecter',
    'login.signUp': 'Inscription',
    'login.backText': 'Retournez',
    'login.homeLink': 'Accueil',
    'login.success': 'Connexion réussie! Redirection...',
    'login.error': 'Erreur de connexion',




       // ConfirmationView
       'confirmation.title': 'Finalisez votre inscription',
       'confirmation.subtitle': 'Créez votre mot de passe pour activer votre compte',
       'confirmation.placeholder.password': 'Créez un mot de passe fort',
       'confirmation.placeholder.confirmPassword': 'Confirmez votre mot de passe',
       'confirmation.passwordRequirements': 'Votre mot de passe doit contenir au moins 8 caractères, incluant une lettre majuscule, une lettre minuscule et un chiffre.',
       'confirmation.loading': 'Traitement en cours...',
       'confirmation.activate': 'Activer mon compte',
       'confirmation.backText': 'Retournez à',
       'confirmation.loginLink': 'la page de connexion',
       'confirmation.success': 'Votre compte a été activé avec succès !',
       'confirmation.invalidToken': 'Token de confirmation manquant ou invalide.',
       'confirmation.passwordMismatch': 'Les mots de passe ne correspondent pas',
       'confirmation.passwordTooShort': 'Le mot de passe doit contenir au moins 8 caractères',
       'confirmation.passwordRequirementsError': 'Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre',
       'confirmation.error': 'La confirmation a échoué. Veuillez réessayer ou demander un nouveau lien.',


        // ForgotPasswordView
    'forgotPassword.title': 'Mot de passe oublié',
    'forgotPassword.subtitle': 'Entrez votre email pour recevoir un lien de réinitialisation',
    'forgotPassword.placeholder.email': 'nom@exemple.com',
    'forgotPassword.loading': 'Envoi en cours...',
    'forgotPassword.send': 'Envoyer le lien de réinitialisation',
    'forgotPassword.backToLogin': 'Retour à la connexion',
    'forgotPassword.error': 'Erreur lors de la demande de réinitialisation',


    // Ajouter dans les traductions fr: {...}
'dashboard.loading': 'Chargement...',
'dashboard.header.welcome': 'Bon retour',
'dashboard.header.welcomeDefault': 'Bienvenue',
'dashboard.header.cardId': 'ID de carte :',
'dashboard.header.cardIdDefault': 'Non défini',

// Sidebar
'dashboard.sidebar.dashboard': 'Tableau de bord',
'dashboard.sidebar.qrcode': 'QR Code et lien Personnel',
'dashboard.sidebar.upgrade': 'Activer votre neolinks',
'dashboard.sidebar.editProfile': 'Modifier votre profil',
'dashboard.sidebar.socialLinks': 'Réseaux sociaux',
'dashboard.sidebar.profilePhotos': 'Photos du profil',
'dashboard.sidebar.appearance': 'Apparence',
'dashboard.sidebar.photos': 'Photos',
'dashboard.sidebar.logout': 'Se déconnecter',

// Notifications
'dashboard.notification.activateSubscription': 'Veuillez',
'dashboard.notification.activateLink': 'activer votre abonnement',
'dashboard.notification.activateText': 'pour accéder à toutes les fonctionnalités.',

// Analytics
'dashboard.analytics.title': 'Tableau de Bord Analytique - Profil Digital ',
'dashboard.analytics.loading': 'Chargement des données...',
'dashboard.analytics.totalScans': 'Total des scans',
'dashboard.analytics.uniqueVisitors': 'Visiteurs uniques',
'dashboard.analytics.conversionRate': 'Taux de conversion',
'dashboard.analytics.topLink': 'Lien le plus cliqué',
'dashboard.analytics.recentScans': 'Scans récents',
'dashboard.analytics.lastMonth': 'par rapport au mois dernier',
'dashboard.analytics.totalClicks': 'du total des clics',
'dashboard.analytics.noRecentScans': 'Aucun scan récent',
'dashboard.analytics.date': 'Date',
'dashboard.analytics.location': 'Lieu',
'dashboard.analytics.device': 'Appareil',

// Profile Edit
'dashboard.profile.title': 'Modifier les informations',
'dashboard.profile.fullName': 'Nom complet',
'dashboard.profile.bio': 'Bio',
'dashboard.profile.company': 'Société',
'dashboard.profile.mobile': 'Mobile',
'dashboard.profile.businessMode': 'Mode Business',
'dashboard.profile.businessCard': 'Carte Business Digitale',
'dashboard.profile.businessDescription': 'Activez les boutons de partage et téléchargement de contact',
'dashboard.profile.businessEnabled': 'Fonctionnalités business activées',
'dashboard.profile.consultationOnly': 'Mode consultation uniquement',
'dashboard.profile.saveChanges': 'Enregistrer les modifications',

// Social Links
'dashboard.social.title': 'Réseaux sociaux et liens personnalisés',
'dashboard.social.noLinks': 'Vous n\'avez pas encore ajouté de liens.',
'dashboard.social.selectType': 'Sélectionner un reseau social ou un lien personnel',
'dashboard.social.customLink': 'Lien personnalisé',
'dashboard.social.customName': 'Nom qui apparaîtra sur votre profil',
'dashboard.social.urlPlaceholder': 'URL complète',
'dashboard.social.add': 'Ajouter',
'dashboard.social.customNamePlaceholder': 'Ex: Mon Portfolio',

// Photos
'dashboard.photos.title': 'Photos',
'dashboard.photos.addPhoto': 'Ajouter une photo',
'dashboard.photos.noPhotos': 'Vous n\'avez pas encore ajouté de photos.',
'dashboard.photos.photo': 'Photo',

// Profile Photos
'dashboard.profilePhotos.title': 'Gestion des photos du profil',
'dashboard.profilePhotos.profilePicture': 'Photo de profil',
'dashboard.profilePhotos.coverImage': 'Image de couverture',
'dashboard.profilePhotos.editProfile': 'Modifier la photo de profil',
'dashboard.profilePhotos.addProfile': 'Ajouter une photo de profil',
'dashboard.profilePhotos.editCover': 'Modifier l\'image de couverture',
'dashboard.profilePhotos.addCover': 'Ajouter une image de couverture',
'dashboard.profilePhotos.info': 'Pour un rendu optimal, utilisez des images de bonne qualité. La photo de profil sera affichée en format carré, tandis que l\'image de couverture sera redimensionnée pour s\'adapter à la largeur de votre profil.',

// Subscription
'dashboard.subscription.title': 'Mettre à niveau votre plan',
'dashboard.subscription.currentPlan': 'Plan actuel',
'dashboard.subscription.validUntil': 'Valide jusqu\'au',
'dashboard.subscription.active': 'Actif',
'dashboard.subscription.choosePlan': 'Choisissez un plan ci-dessous',
'dashboard.subscription.classic': 'Essentiel',
'dashboard.subscription.classicDescription': 'Pour les particuliers avec des fonctionnalités essentielles',
'dashboard.subscription.professional': 'Professionnel',
'dashboard.subscription.professionalDescription': 'Pour les Pros avec sous domaines personnalisée',
'dashboard.subscription.enterprise': 'Plan Entreprise',
'dashboard.subscription.enterpriseDescription': 'Solutions personnalisées pour les grandes équipes',
'dashboard.subscription.currentPlanButton': 'Plan actuel',
'dashboard.subscription.choosePlanButton': 'Choisir ce plan',
'dashboard.subscription.changePlan': 'Changer de plan',
'dashboard.subscription.upgrade': 'Mettre à niveau',
'dashboard.subscription.contactSales': 'Contacter les ventes',
'dashboard.error.subscriptionRequired': 'Veuillez activer votre abonnement pour accéder à toutes les fonctionnalités',

// QR Code
'dashboard.qrcode.title': 'Mon QR Code personnel',
'dashboard.qrcode.copy': 'Copier',
'dashboard.qrcode.openProfile': 'Ouvrir mon profil',
'dashboard.qrcode.noQRCode': 'Vous n\'avez pas encore de QR code',
'dashboard.qrcode.generateDescription': 'Générez votre QR code et lien personnel pour partager votre profil facilement.',
'dashboard.qrcode.generating': 'Génération en cours...',
'dashboard.qrcode.generate': 'Générer mon QR code',
'dashboard.qrcode.premiumFeature': 'Fonctionnalité premium',
'dashboard.qrcode.subscriptionRequired': 'Vous devez avoir un abonnement actif pour générer votre QR code personnel.',
'dashboard.qrcode.activateSubscription': 'Activer un abonnement',

// Appearance
'dashboard.appearance.title': 'Apparence',
'dashboard.appearance.description': 'Personnalisez l\'apparence de votre profil Neolinks en choisissant l\'un de nos thèmes.',
'dashboard.appearance.all': 'Tous',
'dashboard.appearance.active': 'Actif',
'dashboard.appearance.apply': 'Appliquer ce thème',

// Logout
'dashboard.logout.title': 'Se déconnecter',
'dashboard.logout.confirm': 'Êtes-vous sûr de vouloir vous déconnecter ?',
'dashboard.logout.button': 'Se déconnecter',

// Payment Modal
'dashboard.payment.title': 'Choisissez votre mode de paiement',
'dashboard.payment.cash': 'Cash',
'dashboard.payment.cashDescription': 'Paiement en espèces',
'dashboard.payment.wafi': 'Wafi',
'dashboard.payment.wafiDescription': 'Paiement digital',
'dashboard.payment.gateway': 'Payement Gateway',
'dashboard.payment.gatewayDescription': 'Visa / MasterCard',
'dashboard.payment.summary': 'Récapitulatif de la commande',
'dashboard.payment.package': 'Package',

'dashboard.payment.validate': 'Valider le paiement',

'dashboard.payment.orderSummary': 'Récapitulatif de votre commande',
'dashboard.payment.subscription': 'Abonnement',
'dashboard.payment.duration': 'Durée',
'dashboard.payment.oneYear': '1 an',
'dashboard.payment.price': 'Prix',
'dashboard.payment.total': 'Total',
'dashboard.payment.paymentNote': '* Le paiement sera traité en dollar $',

// Contact Modal
'dashboard.contact.title': 'Contactez notre équipe commerciale',
'dashboard.contact.whatsapp': 'WhatsApp',
'dashboard.contact.email': 'Email',

// Dropdown Menu
'dashboard.dropdown.editProfile': 'Modifier le Profil',
'dashboard.dropdown.logout': 'Déconnexion',
'dashboard.sidebar.settings': 'Paramètres',


'dashboard.sidebar.services': 'Services',
'dashboard.services.title': 'Mes Services',
'dashboard.services.description': 'Ajoutez des boutons personnalisés ou des liens vers vos services',
'dashboard.services.current': 'Services actuels',
'dashboard.services.noServices': 'Aucun service ajouté pour le moment',
'dashboard.services.addNew': 'Ajouter un nouveau service',
'dashboard.services.type': 'Type',
'dashboard.services.typeLink': 'Lien simple',
'dashboard.services.typeButton': 'Bouton avec image',
'dashboard.services.name': 'Nom du service',
'dashboard.services.namePlaceholder': 'Ex: Mon Portfolio',
'dashboard.services.url': 'URL',
'dashboard.services.urlPlaceholder': 'https://example.com',
'dashboard.services.icon': 'Icône',
'dashboard.services.optional': 'optionnel',
'dashboard.services.add': 'Ajouter le service',



// PaymentFailure
'paymentFailure.title': 'Paiement échoué',
'paymentFailure.subtitle': 'Une erreur est survenue lors du paiement',
'paymentFailure.defaultMessage': 'Le paiement n\'a pas pu être traité',
'paymentFailure.backToDashboard': 'Retour à votre tableau de bord',

'paymentSuccess.title': 'Paiement réussi !',
'paymentSuccess.subtitle': 'Votre abonnement a été activé avec succès',
'paymentSuccess.reference': 'Référence de transaction :',
'paymentSuccess.backToDashboard': 'Retour au tableau de bord',
'paymentSuccess.autoRedirect': 'Redirection automatique dans',
'paymentSuccess.seconds': 'secondes',
// ✅ MÉTADONNÉES
'meta.discoverProfile': 'Découvrez mon profil',


'showcase.title': 'Ils nous font confiance',
'showcase.subtitle': 'Découvrez comment nos utilisateurs transforment leur présence digitale avec NeoLinks',
'showcase.cta.title': 'Rejoignez nous',
'showcase.cta.description': 'En adoptant neolinks, vous participez à une action verte. Utilisez votre smartphone pour le networking au lieu des cartes de visite papier   qui causent pollution et déforestation. Construisons un monde meilleur pour les  générations futurs.',
'showcase.cta.button': 'Je crée mon profil digital',
'showcase.scrollHint': 'Faites défiler pour voir plus de profils',



// ThreeWays Section
'threeways.title': 'Un outil, trois façons de l\'essayer.',
'threeways.tabs.nfc': 'Digital Business Card',
'threeways.tabs.linkinbio': 'Link In Bio',
'threeways.tabs.qrcode': 'Digital Sharing',

// Link In Bio
'threeways.linkinbio.title': 'un Link in Bio qui fait toute la différence',
'threeways.linkinbio.description': 'Regroupez tous vos liens au même endroit, sur une plateforme qui allie design et simplicité.',
'threeways.linkinbio.features.unlimited': 'Liens illimités',
'threeways.linkinbio.features.customizable': 'Redirection vers tous vos assets digitaux',
'threeways.linkinbio.features.statistics': 'Statistiques détaillées',
'threeways.linkinbio.claim.label': 'Réclamez votre neolinks.me',
'threeways.linkinbio.claim.placeholder': 'pseudo',
'threeways.linkinbio.claim.button': 'Commencer',

// NFC Card
'threeways.nfc.title': 'Carte de visite digitale NFC',
'threeways.nfc.description': 'Remplacer le carte de visite papier par une seule carte NFC intelligente. Un simple tap pour partager vos informations.',
'threeways.nfc.cards.white.name': 'White Corporate',
'threeways.nfc.cards.white.desc': 'Design minimaliste',
'threeways.nfc.cards.silver.name': 'Silver VIP',
'threeways.nfc.cards.silver.desc': 'Élégance ',
'threeways.nfc.cards.golden.name': 'Golden Card',
'threeways.nfc.cards.golden.desc': 'Exclusif',

// Digital Sharing
'threeways.qrcode.title': 'Digital Sharing',
'threeways.qrcode.description': 'Partagez votre profil digital partout : QR Code, lien direct, Chat, réseaux sociaux. Une solution complète.',
'threeways.qrcode.features.customizable': 'QR Code ',
'threeways.qrcode.features.multiplatform': 'Partage multi-plateformes',
'threeways.qrcode.features.analytics': 'Analytics temps réel',


  "dashboard": {
    "sidebar": {
      "services": "Services"
    },
    "services": {
      "title": "Mes Services",
      "description": "Ajoutez des boutons personnalisés ou des liens vers vos services",
      "current": "Services actuels",
      "noServices": "Aucun service ajouté pour le moment",
      "addNew": "Ajouter un nouveau service",
      "type": "Type",
      "typeLink": "Lien simple",
      "typeButton": "Bouton avec image",
      "name": "Nom du service",
      "namePlaceholder": "Ex: Mon Portfolio",
      "url": "URL",
      "urlPlaceholder": "https://example.com",
      "icon": "Icône",
      "optional": "optionnel",
      "add": "Ajouter le service"
    }
  }

  },
  
  // ANGLAIS
  en: {
    // Header
    'menu.home': 'Home',
    'menu.features': 'Features',
    'menu.pricing': 'Pricing', 
    'menu.faq': 'FAQ',
    'button.getYourNeolink': 'Get your neolinks',
    
    // Hero section - NOUVELLES TRADUCTIONS
    'hero.title.part1': 'YOUR ONE',
    'hero.title.part2': 'DIGITAL',
'hero.title.part3': 'PROFILE',
    'hero.subtitle': 'Centralize all your links in one place: social media, shop, courses... Transform your Neolinks into a real digital business card.',
    'hero.button.order': 'Order now',
    'hero.button.login': 'Login', 


     // ProductSection
     'product.video.title': 'How to create your digital profile with neolinks',
     'product.button.start': 'Get started now',
     'product.button.youtube': 'Watch on YouTube',
     'product.benefit1.title': 'Quick setup',
     'product.benefit1.description': 'Profile ready in less than 5 minutes',
     'product.benefit2.title': 'Instant sharing',
     'product.benefit2.description': 'All your information in one tap',
     'product.benefit3.title': 'Always up to date',
     'product.benefit3.description': 'Update your information anytime',


     // FeatureSection
 


     // Remplacer l'ancienne ligne :
'features.title': 'Feature  to build a digital profile',
// Par :
'features.mainTitle': 'All features for your digital success',

// Ajouter ces nouvelles traductions :
'features.linkInBio.title': 'Link in Bio',
'features.linkInBio.description': 'Centralize all your links in one place',
'features.dashboard.title': 'Dashboard',
'features.dashboard.description': 'Detailed statistics and digital strategy for Personnal branding',
'features.networking.title': 'Networking',
'features.networking.description': 'Conferences, trade shows and events',
'features.qrVcard.title': 'Digital Sharing',
'features.qrVcard.description': 'Instant  sharing',
'features.content.title': 'Content',
'features.content.description': 'Ebooks, videos, products and more',
'features.socialMedia.title': 'Social Media',
'features.socialMedia.description': 'Connect all your profiles',
'features.appLinks.title': 'App Links',
'features.appLinks.description': 'Smart mobile redirection',

'features.themes.title': 'Themes',
'features.themes.description': 'Customizable designs',
'features.whatsapp': 'WhatsApp',
      // PricingSection
  


      'pricing.title': 'Choose your plan',
  
  // ESSENTIAL
  'pricing.essential.title': 'Essential',
  'pricing.essential.subtitle': 'For individuals',
  'pricing.essential.price': '5,000',
  'pricing.essential.currency': 'FDJ',
  'pricing.essential.period': 'year',
  'pricing.essential.features': [
    'Personal bio link',
    'Social media',
    'Custom links (portfolio, courses...)',
    'Digital business card mode',
    'Statistics',
    'Themes'
  ],
  'pricing.essential.button': 'Get started',
  
  // VIP SILVER
  'pricing.silver.title': 'VIP Silver',
  'pricing.silver.subtitle': 'For professionals',
  'pricing.silver.price': '10,000',
  'pricing.silver.currency': 'FDJ',
  'pricing.silver.period': 'year',
  'pricing.silver.features': [
    'Everything in Essential',
    'Special domain username.neolinks.me',
    'Priority customer support',
    'Premium silver business card',
    'Advanced analytics',
    'Ad-free'
  ],
  'pricing.silver.button': 'Choose Silver',
  
  // GOLDEN VIP
  'pricing.gold.title': 'Golden VIP',
  'pricing.gold.subtitle': 'For experts',
  'pricing.gold.price': '15,000',
  'pricing.gold.currency': 'FDJ',
  'pricing.gold.period': 'year',
  'pricing.gold.features': [
    'Everything in Silver',
    'Premium golden business card',
    'Custom domain',
    '24/7 priority support',
    'Advanced integrations',
    'Custom branding'
  ],
  'pricing.gold.button': 'Choose Gold',
  
  // ENTERPRISE
  'pricing.enterprise.title': 'Enterprise',
  'pricing.enterprise.subtitle': 'For teams',
  'pricing.enterprise.price': 'Custom',
  'pricing.enterprise.features': [
    'Multi-user solutions',
    'Custom branding',
    'Enterprise domains',
    'Centralized management',
    'Dedicated support',
    'Team training',
    'API integration'
  ],
      'pricing.enterprise.button': 'Contact sales',

       // FaqSection
    'faq.title': 'Frequently Asked Questions',
    'faq.q1.question': 'How does neolinks work?',
    'faq.q1.answer': 'Neolinks creates a unique digital profile accessible via your personalized link (e.g., neolinks.me/yourname). Place this link in your Instagram, LinkedIn, TikTok bios to be easily discovered across all your networks. Your contacts instantly access your information: social media, portfolio, courses, e-commerce shop, contact details, and can save your contact with one click. One link to centralize everything!',
    'faq.q2.question': 'Can I update my information after creation?',
    'faq.q2.answer': 'Absolutely! You can update your information anytime via your dashboard. Modify your links, change your photo, add new social networks - all changes are reflected immediately on your neolinks profile.',
   'faq.q3.question': 'How can I convert my neolinks into a digital business card?',
    'faq.q3.answer': 'Go to your dashboard, navigate to "Edit your profile" and activate "Business Mode". Your profile then becomes scannable by QR code by your contacts, with a "Save contact" button that allows them to instantly add your information to their address book.',
    'faq.q4.question': 'What\'s the difference between Essential and Professional plans?',
    'faq.q4.answer': 'The Essential plan ($15/year) offers all basic features: bio link, social media, custom links, business card mode and statistics. The Professional plan ($25/year) adds a custom domain (yourname.neolink.me), advanced analytics, custom themes and priority support.',

'contact.save': 'Save',

    // Footer
    'footer.copyright': 'All rights reserved.',
    'footer.backToTop': 'Back to top',


    // InscriptionView
    'inscription.title': 'Create Your Account',
    'inscription.subtitle': 'Get started with your neolinks',
    'inscription.placeholder.name': 'Enter your full name',
    'inscription.placeholder.email': 'Email',
    'inscription.emailInfo': 'A confirmation email will be sent to your email address to finalize your registration and create your password.',
    'inscription.terms': 'I accept the terms of use and privacy policy',
    'inscription.loading': 'Loading...',
    'inscription.submit': 'Submit',
    'inscription.or': 'or',
    'inscription.loginButton': 'Sign in',
    'inscription.backText': 'Return to',
    'inscription.homeLink': 'Home',
    'inscription.success': 'Registration successful! Please check your email to confirm your account and create a password.',
    'inscription.error': 'Registration failed. Please try again.',

    'inscription.claimLink': 'Claim your unique link',
'inscription.placeholder.username': 'yourname',
'inscription.usernameAvailable': '✅ Available!',
'inscription.usernameRequirements': '3-20 characters, letters and numbers only',
'inscription.referral.invited': 'You have been invited by a partner!',
'inscription.referral.code': 'Referral code:',



// ThreeWays Section
'threeways.title': 'One tool, three ways to try it.',
'threeways.tabs.nfc': 'Digital Business Card',
'threeways.tabs.linkinbio': 'Link In Bio',
'threeways.tabs.qrcode': 'Digital Sharing',

// Link In Bio
'threeways.linkinbio.title': 'A Link in Bio that makes all the difference',
'threeways.linkinbio.description': 'Bring all your links together in one place, on a platform that combines design and simplicity.',
'threeways.linkinbio.features.unlimited': 'Unlimited links',
'threeways.linkinbio.features.customizable': 'Redirect to all your digital assets',
'threeways.linkinbio.features.statistics': 'Detailed statistics',
'threeways.linkinbio.claim.label': 'Claim your neolinks.me',
'threeways.linkinbio.claim.placeholder': 'username',
'threeways.linkinbio.claim.button': 'Get Started',

// NFC Card
'threeways.nfc.title': 'Digital NFC Business Card',
'threeways.nfc.description': 'Replace paper business cards with a single smart NFC card. A simple tap to share your information.',
'threeways.nfc.cards.white.name': 'White Corporate',
'threeways.nfc.cards.white.desc': 'Minimalist design',
'threeways.nfc.cards.silver.name': 'Silver VIP',
'threeways.nfc.cards.silver.desc': 'Elegance',
'threeways.nfc.cards.golden.name': 'Golden Card',
'threeways.nfc.cards.golden.desc': 'Exclusive ',

// Digital Sharing
'threeways.qrcode.title': 'Digital Sharing',
'threeways.qrcode.description': 'Share your digital profile everywhere: QR Code, direct link, Chat, social networks. A complete solution.',
'threeways.qrcode.features.customizable': 'QR Code',
'threeways.qrcode.features.multiplatform': 'Multi-platform sharing',
'threeways.qrcode.features.analytics': 'Real-time analytics',


      // LoginView
      'login.title': 'Welcome Back',
      'login.subtitle': 'Sign in to your neolinks account',
      'login.placeholder.email': 'name@example.com',
      'login.placeholder.password': 'Enter your password',
      'login.rememberMe': 'Remember me',
      'login.forgotPassword': 'Forgot password?',
      'login.loading': 'Loading...',
      'login.signIn': 'Sign in',
      'login.signUp': 'Sign up',
      'login.backText': 'Return to',
      'login.homeLink': 'Home',
      'login.success': 'Login successful! Redirecting...',
      'login.error': 'Login error',


      // ConfirmationView
    'confirmation.title': 'Complete Your Registration',
    'confirmation.subtitle': 'Create your password to activate your account',
    'confirmation.placeholder.password': 'Create a strong password',
    'confirmation.placeholder.confirmPassword': 'Confirm your password',
    'confirmation.passwordRequirements': 'Your password must contain at least 8 characters, including an uppercase letter, a lowercase letter and a number.',
    'confirmation.loading': 'Processing...',
    'confirmation.activate': 'Activate my account',
    'confirmation.backText': 'Return to',
    'confirmation.loginLink': 'the login page',
    'confirmation.success': 'Your account has been successfully activated!',
    'confirmation.invalidToken': 'Missing or invalid confirmation token.',
    'confirmation.passwordMismatch': 'Passwords do not match',
    'confirmation.passwordTooShort': 'Password must contain at least 8 characters',
    'confirmation.passwordRequirementsError': 'Password must contain at least one uppercase letter, one lowercase letter and one number',
    'confirmation.error': 'Confirmation failed. Please try again or request a new link.',

    // ForgotPasswordView
    'forgotPassword.title': 'Forgot Password',
    'forgotPassword.subtitle': 'Enter your email to receive a reset link',
    'forgotPassword.placeholder.email': 'name@example.com',
    'forgotPassword.loading': 'Sending...',
    'forgotPassword.send': 'Send reset link',
    'forgotPassword.backToLogin': 'Back to login',
    'forgotPassword.error': 'Error requesting password reset',


 // Ajouter dans les traductions en: {...}
'dashboard.loading': 'Loading...',
'dashboard.header.welcome': 'Welcome back',
'dashboard.header.welcomeDefault': 'Welcome',
'dashboard.header.cardId': 'Card ID:',
'dashboard.header.cardIdDefault': 'Not defined',

// Sidebar
'dashboard.sidebar.dashboard': 'Dashboard',
'dashboard.sidebar.qrcode': 'QR Code and Personal Link',
'dashboard.sidebar.upgrade': 'Activate your neolinks',
'dashboard.sidebar.editProfile': 'Edit your profile',
'dashboard.sidebar.socialLinks': 'Social networks',
'dashboard.sidebar.profilePhotos': 'Profile photos',
'dashboard.sidebar.appearance': 'Appearance',
'dashboard.sidebar.photos': 'Photos',
'dashboard.sidebar.logout': 'Log out',

// Notifications
'dashboard.notification.activateSubscription': 'Please',
'dashboard.notification.activateLink': 'activate your subscription',
'dashboard.notification.activateText': 'to access all features.',

// Analytics
'dashboard.analytics.title': 'Digital Profile Analytics Dashboard',
'dashboard.analytics.loading': 'Loading data...',
'dashboard.analytics.totalScans': 'Total scans',
'dashboard.analytics.uniqueVisitors': 'Unique visitors',
'dashboard.analytics.conversionRate': 'Conversion rate',
'dashboard.analytics.topLink': 'Top clicked link',
'dashboard.analytics.recentScans': 'Recent scans',
'dashboard.analytics.lastMonth': 'compared to last month',
'dashboard.analytics.totalClicks': 'of total clicks',
'dashboard.analytics.noRecentScans': 'No recent scans',
'dashboard.analytics.date': 'Date',
'dashboard.analytics.location': 'Location',
'dashboard.analytics.device': 'Device',

// Profile Edit
'dashboard.profile.title': 'Edit information',
'dashboard.profile.fullName': 'Full name',
'dashboard.profile.bio': 'Bio',
'dashboard.profile.company': 'Company',
'dashboard.profile.mobile': 'Mobile',
'dashboard.profile.businessMode': 'Business Mode',
'dashboard.profile.businessCard': 'Digital Business Card',
'dashboard.profile.businessDescription': 'Enable sharing and contact download buttons',
'dashboard.profile.businessEnabled': 'Business features enabled',
'dashboard.profile.consultationOnly': 'View-only mode',
'dashboard.profile.saveChanges': 'Save changes',

// Social Links
'dashboard.social.title': 'Social networks and custom links',
'dashboard.social.noLinks': 'You haven\'t added any links yet.',
'dashboard.social.selectType': 'Select a social network or personal link',
'dashboard.social.customLink': 'Custom link',
'dashboard.social.customName': 'Name that will appear on your profile',
'dashboard.social.urlPlaceholder': 'Full URL',
'dashboard.social.add': 'Add',
'dashboard.social.customNamePlaceholder': 'e.g.: My Portfolio',

// Photos
'dashboard.photos.title': 'Photos',
'dashboard.photos.addPhoto': 'Add a photo',
'dashboard.photos.noPhotos': 'You haven\'t added any photos yet.',
'dashboard.photos.photo': 'Photo',

// Profile Photos
'dashboard.profilePhotos.title': 'Profile photo management',
'dashboard.profilePhotos.profilePicture': 'Profile picture',
'dashboard.profilePhotos.coverImage': 'Cover image',
'dashboard.profilePhotos.editProfile': 'Edit profile picture',
'dashboard.profilePhotos.addProfile': 'Add a profile picture',
'dashboard.profilePhotos.editCover': 'Edit cover image',
'dashboard.profilePhotos.addCover': 'Add a cover image',
'dashboard.profilePhotos.info': 'For optimal rendering, use high-quality images. The profile picture will be displayed in square format, while the cover image will be resized to fit your profile width.',

// Subscription
'dashboard.subscription.title': 'Upgrade your plan',
'dashboard.subscription.currentPlan': 'Current plan',
'dashboard.subscription.validUntil': 'Valid until',
'dashboard.subscription.active': 'Active',
'dashboard.subscription.choosePlan': 'Choose a plan below',
'dashboard.subscription.classic': 'Essential',
'dashboard.subscription.classicDescription': 'For individuals with essential features',
'dashboard.subscription.professional': 'Professional', 
'dashboard.subscription.professionalDescription': 'For Pros with custom subdomains',
'dashboard.subscription.enterprise': 'Enterprise Plan',
'dashboard.subscription.enterpriseDescription': 'Custom solutions for large teams',
'dashboard.subscription.currentPlanButton': 'Current plan',
'dashboard.subscription.choosePlanButton': 'Choose this plan',
'dashboard.subscription.changePlan': 'Change plan',
'dashboard.subscription.upgrade': 'Upgrade',
'dashboard.subscription.contactSales': 'Contact sales',
'dashboard.error.subscriptionRequired': 'Please activate your subscription to access all features',

// QR Code
'dashboard.qrcode.title': 'My personal QR Code',
'dashboard.qrcode.copy': 'Copy',
'dashboard.qrcode.openProfile': 'Open my profile',
'dashboard.qrcode.noQRCode': 'You don\'t have a QR code yet',
'dashboard.qrcode.generateDescription': 'Generate your QR code and personal link to easily share your profile.',
'dashboard.qrcode.generating': 'Generating...',
'dashboard.qrcode.generate': 'Generate my QR code',
'dashboard.qrcode.premiumFeature': 'Premium feature',
'dashboard.qrcode.subscriptionRequired': 'You must have an active subscription to generate your personal QR code.',
'dashboard.qrcode.activateSubscription': 'Activate subscription',

// Appearance
'dashboard.appearance.title': 'Appearance',
'dashboard.appearance.description': 'Customize your Neolinks profile appearance by choosing one of our themes.',
'dashboard.appearance.all': 'All',
'dashboard.appearance.active': 'Active',
'dashboard.appearance.apply': 'Apply this theme',

// Logout
'dashboard.logout.title': 'Log out',
'dashboard.logout.confirm': 'Are you sure you want to log out?',
'dashboard.logout.button': 'Log out',

// Payment Modal
'dashboard.payment.title': 'Choose your payment method',
'dashboard.payment.cash': 'Cash',
'dashboard.payment.cashDescription': 'Cash payment',
'dashboard.payment.wafi': 'Wafi',
'dashboard.payment.wafiDescription': 'Digital payment',
'dashboard.payment.gateway': 'Payment Gateway',
'dashboard.payment.gatewayDescription': 'Visa / MasterCard',
'dashboard.payment.summary': 'Order summary',
'dashboard.payment.package': 'Package',

'dashboard.payment.validate': 'Validate payment',

// Dans la section en: {...} - ajoutez ces lignes dans "Payment Modal"
'dashboard.payment.orderSummary': 'Order summary',
'dashboard.payment.subscription': 'Subscription',
'dashboard.payment.duration': 'Duration', 
'dashboard.payment.oneYear': '1 year',
'dashboard.payment.price': 'Price',
'dashboard.payment.total': 'Total',
'dashboard.payment.paymentNote': '* Payment will be processed in USD $',

// Contact Modal
'dashboard.contact.title': 'Contact our sales team',
'dashboard.contact.whatsapp': 'WhatsApp',
'dashboard.contact.email': 'Email',

// Dropdown Menu
'dashboard.dropdown.editProfile': 'Edit Profile',
'dashboard.dropdown.logout': 'Logout',


'dashboard.sidebar.services': 'Services',
'dashboard.services.title': 'My Services',
'dashboard.services.description': 'Add custom buttons or links to your services',
'dashboard.services.current': 'Current services',
'dashboard.services.noServices': 'No services added yet',
'dashboard.services.addNew': 'Add new service',
'dashboard.services.type': 'Type',
'dashboard.services.typeLink': 'Simple link',
'dashboard.services.typeButton': 'Button with image',
'dashboard.services.name': 'Service name',
'dashboard.services.namePlaceholder': 'Ex: My Portfolio',
'dashboard.services.url': 'URL',
'dashboard.services.urlPlaceholder': 'https://example.com',
'dashboard.services.icon': 'Icon',
'dashboard.services.optional': 'optional',
'dashboard.services.add': 'Add service',

// PaymentFailure
'paymentFailure.title': 'Payment Failed',
'paymentFailure.subtitle': 'An error occurred during payment',
'paymentFailure.defaultMessage': 'Payment could not be processed',
'paymentFailure.backToDashboard': 'Back to your dashboard',


'paymentSuccess.title': 'Payment Successful!',
'paymentSuccess.subtitle': 'Your subscription has been activated successfully',
'paymentSuccess.reference': 'Transaction reference:',
'paymentSuccess.backToDashboard': 'Back to dashboard',
'paymentSuccess.autoRedirect': 'Automatic redirect in',
'paymentSuccess.seconds': 'seconds',
     // ✅ MÉTADONNÉES  
'meta.discoverProfile': 'Discover my profile',
'dashboard.sidebar.settings': 'Settings',

'showcase.title': 'They trust us',
'showcase.subtitle': 'Discover how our users transform their digital presence with NeoLinks',
'showcase.cta.title': 'Join us',
'showcase.cta.description': 'When you adopt neolinks, you make a green action. Network directly from your smartphone instead of using paper business cards that cause pollution and deforestation. Let\'s build a better world for the futur generation.',
'showcase.cta.button': 'I create my digital profile',
'showcase.scrollHint': 'Swipe to see more profiles',


"dashboard": {
    "sidebar": {
      "services": "Services"
    },
    "services": {
      "title": "My Services",
      "description": "Add custom buttons or links to your services",
      "current": "Current services",
      "noServices": "No services added yet",
      "addNew": "Add new service",
      "type": "Type",
      "typeLink": "Simple link",
      "typeButton": "Button with image",
      "name": "Service name",
      "namePlaceholder": "Ex: My Portfolio",
      "url": "URL",
      "urlPlaceholder": "https://example.com",
      "icon": "Icon",
      "optional": "optional",
      "add": "Add service"
    }
  }

  }
}
// Fonction pour utiliser les traductions
export function useTranslation() {
  
  // Changer de langue (maintenant avec persistance automatique)
  const setLanguage = (lang) => {
    if (['fr', 'en'].includes(lang)) {
      currentLanguage.value = lang
      // La sauvegarde se fait automatiquement via le watcher
    }
  }
  
  // Obtenir une traduction
  const t = (key) => {
    return translations[currentLanguage.value][key] || key
  }
  
  // Vérifier si c'est la langue actuelle  
  const isCurrentLanguage = (lang) => {
    return currentLanguage.value === lang
  }
  
  return {
    currentLanguage,
    setLanguage,
    t,
    isCurrentLanguage
  }
}